import type { SentryProductStatusTagMapping } from '../types';

/** Sentry context card name for full product-status map */
export const PRODUCT_STATUS_CONTEXT_NAME = 'Product status';

/** Product codes that become filterable tags (rest stay in context only) */
export const HIGH_SIGNAL_PRODUCT_STATUS_TAGS: ReadonlyArray<SentryProductStatusTagMapping> =
  [
    { tag: 'pg_status', code: 'PG' },
    { tag: 'epos_status', code: 'EPOS' },
    { tag: 'router_status', code: 'ROUTER' },
    { tag: 'payouts_status', code: 'CSP' },
    { tag: 'riskshield_status', code: 'PGRS' },
  ];

export const HIGH_SIGNAL_PRODUCT_STATUS_TAG_KEYS =
  HIGH_SIGNAL_PRODUCT_STATUS_TAGS.map(h => h.tag);

/** IMPC values that enable import-merchant UI */
export const IMPORT_MERCHANT_ENABLED_STATUSES = [
  'APPROVED',
  'UNDER_REVIEW',
] as const;
